// dependencies
import { Map, List } from "immutable";

// selectors
import { getUI } from "Selectors/ui";

export const getReportID = (state) => getUI(state).get("reportID", "");
export const getAuthorValue = (state) => getUI(state).get("author", Map());
export const getCurrentPage = (state) => getUI(state).get("currentPage", 1);
export const getCompanyValue = (state) => getUI(state).get("company", Map());
export const getReviewReports = (state) => getUI(state).get("reviewReports", List());
